import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { Login } from "./views/Login";
import { NoAccess } from "./views/NoAccess";
import { Users } from "./views/Users";
import { UserDetail } from "./views/UserDetail";
import { ProductDetail } from "./views/ProductDetail";
import { RunTraceView } from "./views/RunTrace";
import { Plans } from "./views/Plans";
import { AuditLog } from "./views/AuditLog";
import { Metrics } from "./views/Metrics";
import { SubPromptsList } from "./views/SubPromptsList";
import { SubPromptsDetail } from "./views/SubPromptsDetail";
import { ProductsSubCalls } from "./views/ProductsSubCalls";
import { AllRuns } from "./views/AllRuns";
import { AllProducts } from "./views/AllProducts";
import { Settings } from "./views/Settings";
import { Alerts } from "./views/Alerts";
import { ToastRegion } from "./components/Toast";
import { AdminAlertNotifier } from "./components/AdminAlertNotifier";

export function App() {
  return (
    <>
      <ToastRegion />
      <AdminAlertNotifier />
      <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/no-access" element={<NoAccess />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Users />
          </RequireAuth>
        }
      />
      <Route
        path="/users/:uid"
        element={
          <RequireAuth>
            <UserDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/users/:uid/products/:pid"
        element={
          <RequireAuth>
            <ProductDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/users/:uid/products/:pid/runs/:rid"
        element={
          <RequireAuth>
            <RunTraceView />
          </RequireAuth>
        }
      />
      <Route
        path="/plans"
        element={
          <RequireAuth>
            <Plans />
          </RequireAuth>
        }
      />
      <Route
        path="/audit"
        element={
          <RequireAuth>
            <AuditLog />
          </RequireAuth>
        }
      />
      <Route
        path="/metrics"
        element={
          <RequireAuth>
            <Metrics />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/sub-prompts"
        element={
          <RequireAuth>
            <SubPromptsList />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/sub-prompts/:subPromptId"
        element={
          <RequireAuth>
            <SubPromptsDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/products/:pid/sub-calls/:subPromptId"
        element={
          <RequireAuth>
            <ProductsSubCalls />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/runs"
        element={
          <RequireAuth>
            <AllRuns />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/alerts"
        element={
          <RequireAuth>
            <Alerts />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/products"
        element={
          <RequireAuth>
            <AllProducts />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <RequireAuth>
            <Settings />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
